import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchBlog(ctx, queryParams){

            var data = JSON.stringify(queryParams);
      
            return new Promise((resolve, reject) => {
                
                axios
                .get('blog/v1/list', { data:data })
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        
        },
        fetchDelete(ctx,id){
        return new Promise((resolve, reject) => {
            axios
            .delete('/blog/v1/delete/'+id)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
        }
        
    }
}